import React from "react";
import riyad from "../../img/riyad2.png";
import "../../App.css";
import "./About.css";
import Fade from "react-reveal";
const About = () => {
  return (
    <div id="aboutt" className="pb-5 pt-5">
      <section className="text-white container">
        <Fade bottom duration={2500} distance="40px">
          <div className="row pt-5  pb-5">
            <div className="col col-lg-5 col-md-5 col-sm-12 col-12">
              <img src={riyad} className="img-fluid" alt="" />
            </div>
            <div className="col col-lg-7 col-md-7 col-sm-12 col-12">
              <h1 className="fw-bold about1">
                <span className="about">About</span> Me
              </h1>
              <p className="mt-4">
                I am a passionate Competitive Programmer and Problem Solver who
                has solved 1000+ algorithmic problems across various online
                judges. I am skilled in C++, Data Structures & Algorithms (DSA),
                OOP, DBMS, C#, Python, Java, JavaScript, TypeScript, SQL, .NET,
                ASP.NET Core, React, Next.js, Node.js, Express.js, MongoDB, and
                MySQL. I am always eager to learn new technologies, solve
                challenging problems, and build efficient software solutions.
              </p>
              <p>
                {" "}
                <span className="under pb-1">
                  Here are a few technologies I've been working with recently :
                </span>
              </p>
              <h4 className="fs-3 fw-bold">Programming & CS</h4>
              <p>
                <span className="bullet fw-bold">1.</span>{" "}
                <li className="pe-3">C++</li>
                <span className="bullet fw-bold">2.</span>{" "}
                <li className="pe-3">C#</li>
                <span className="bullet fw-bold">3.</span>{" "}
                <li className="pe-3">Python</li>
                <span className="bullet fw-bold">4.</span>{" "}
                <li className="pe-3">Java</li>
                <span className="bullet fw-bold">5.</span>{" "}
                <li className="pe-3">JavaScript (ES6)</li>
                <span className="bullet fw-bold">6.</span>{" "}
                <li className="pe-3">TypeScript</li>
                <span className="bullet fw-bold">7.</span>{" "}
                <li className="pe-3">Data Structures & Algorithms</li>
                <span className="bullet fw-bold">8.</span>{" "}
                <li className="pe-3">Competitive Programming</li>
                <span className="bullet fw-bold">9.</span>{" "}
                <li className="pe-3">OOP</li>
                <span className="bullet fw-bold">10.</span>{" "}
                <li className="pe-3">DBMS</li>
                <span className="bullet fw-bold">11.</span>{" "}
                <li className="pe-3">SQL</li>
              </p>

              <h4 className="fs-3 fw-bold">Technologies & Frameworks</h4>
              <p>
                <span className="bullet fw-bold">1.</span>{" "}
                <li className="pe-3">React.js</li>
                <span className="bullet fw-bold">2.</span>{" "}
                <li className="pe-3">Next.js</li>
                <span className="bullet fw-bold">3.</span>{" "}
                <li className="pe-3">Redux & RTK Query</li>
                <span className="bullet fw-bold">4.</span>{" "}
                <li className="pe-3">Tailwind CSS</li>
                <span className="bullet fw-bold">5.</span>{" "}
                <li className="pe-3">Node.js</li>
                <span className="bullet fw-bold">6.</span>{" "}
                <li className="pe-3">Express.js</li>
                <span className="bullet fw-bold">7.</span>{" "}
                <li className="pe-3">ASP.NET Core</li>
                <span className="bullet fw-bold">8.</span>{" "}
                <li className="pe-3">ASP.NET Core MVC</li>
                <span className="bullet fw-bold">9.</span>{" "}
                <li className="pe-3">ASP.NET Core Web API</li>
                <span className="bullet fw-bold">10.</span>{" "}
                <li className="pe-3">Prisma</li>
                <span className="bullet fw-bold">11.</span>{" "}
                <li className="pe-3">Entity Framework Core</li>
              </p>

              <h4 className="fs-3 fw-bold">Databases & Tools</h4>
              <p>
                <span className="bullet fw-bold">1.</span>{" "}
                <li className="pe-3">MongoDB</li>
                <span className="bullet fw-bold">2.</span>{" "}
                <li className="pe-3">MySQL</li>
                <span className="bullet fw-bold">3.</span>{" "}
                <li className="pe-3">Git & GitHub</li>
                <span className="bullet fw-bold">4.</span>{" "}
                <li className="pe-3">NPM</li>
                <span className="bullet fw-bold">5.</span>{" "}
                <li className="pe-3">Visual Studio Code</li>
                <span className="bullet fw-bold">6.</span>{" "}
                <li className="pe-3">Chrome DevTools</li>
                <span className="bullet fw-bold">7.</span>{" "}
                <li className="pe-3">Firebase</li>
                <span className="bullet fw-bold">8.</span>{" "}
                <li className="pe-3">Netlify</li>
                <span className="bullet fw-bold">9.</span>{" "}
                <li className="pe-3">Render</li>
              </p>
              <div className="mt-5">
                <a
                  href="https://github.com/mdriyadtalukder"
                  className="btn text-white ico "
                  target="_blank"
                >
                  {" "}
                  <i class="fab fa-github"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/md-riyad-talukder-913978210/"
                  className="btn text-white ico ms-2 "
                  target="_blank"
                >
                  {" "}
                  <i class="fab fa-linkedin-in"></i>
                </a>
                <a
                  href="mailto:mdriyadtalukder.cse@gmail.com"
                  className="btn text-white ico ms-2"
                >
                  <i class="fas fa-envelope"></i>
                </a>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    </div>
  );
};

export default About;
